import { render, staticRenderFns } from "./FormStartTransfer.vue?vue&type=template&id=6bdf545c&scoped=true"
import script from "./FormStartTransfer.vue?vue&type=script&lang=js"
export * from "./FormStartTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf545c",
  null
  
)

export default component.exports